import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=a6393fac"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6393fac')) {
      api.createRecord('a6393fac', component.options)
    } else {
      api.reload('a6393fac', component.options)
    }
    module.hot.accept("./Detail.vue?vue&type=template&id=a6393fac", function () {
      api.rerender('a6393fac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/queryList/Detail.vue"
export default component.exports